import React, { FC, useMemo, useState, useEffect } from "react";
import ListingsPageHeader from "components/Heading/ListingsPageHeader";
import ListingCard from "components/StayCard/ListingCard";
import ListingCardSkeleton from "components/StayCard/ListingCardSkelleton";
import PaginationComponent from "shared/Pagination/PaginationExt";

import { useClient } from "ClientContext";
import { useGetListings } from "hooks/useGetListings";


export interface SectionGridFilterCardProps {
  loading: boolean;
  className?: string;
  listings: Array<any>; // Define listings as array of any (replace with your data type)
  cachedListings?: Array<any>;
  handlePageChange: (page: number) => void;
}



const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  loading,
  className = "",
  listings,
  cachedListings = [],
  handlePageChange,


}) => {
  const { integration_TYPE } = useClient();

  const {currentPage,totalListings,totalListingFound,totalListingPerPage,listingsLoading} = useGetListings();

  const [currentPageListings, setCurrentPageListings] = useState<any[]>([]);
  const [pageIsLoading, setPageIsLoading] = useState(false);
  const [pageError, setPageError] = useState(false);


  const itemsPerPage = integration_TYPE === "lodgify" ? 12 : totalListingPerPage;
  const skeletonLength = Array(itemsPerPage).fill(0);

  // Combine listings and cachedListings to calculate displayListings
  const displayListings = useMemo(() => {
    if (loading) return []; // Avoid unnecessary computation during loading
    return listings.length > 0 ? listings : cachedListings;
  }, [loading, listings, cachedListings]);


  // Calculate the items to display whenever `currentPage` or `displayListings` changes
  useEffect(() => {
    if (displayListings.length === 0) return;

    setCurrentPageListings(displayListings);

  }, [displayListings, currentPage, itemsPerPage, integration_TYPE]);

  // Memoize listing cards or skeletons based on loading and currentPageListings
  const memoizedListingCards = useMemo(() => {
    if (loading) {
      return skeletonLength.map((_, index) => (
        <ListingCardSkeleton key={`skeleton-${index}`} />
      ));
    } else {
      return currentPageListings.map((stay: any) => (
        <ListingCard key={stay.id} data={stay} />
      ));
    }
  }, [loading, pageIsLoading, currentPage, skeletonLength]);

  const paginationItems = totalListingFound || 0;

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <ListingsPageHeader />

      <div className="mb-8 lg:mb-11">{/* <TabFilters /> */}</div>

      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {memoizedListingCards}
      </div>

      {/* Show pagination only if there are more items than ITEMS_PER_PAGE */}
      {!listingsLoading && totalListings > itemsPerPage && (
        <div className="flex mt-16 justify-center items-center">
          <PaginationComponent
            totalItems={paginationItems}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            currentPage={currentPage}
          />
        </div>
      )}
    </div>
  );
};

export default SectionGridFilterCard;
